require('dotenv').config();
/* eslint-disable max-len */

module.exports = {

  port: process.env.PORT, // Node.js app
  trustProxy: 'loopback', // https://expressjs.com/en/guide/behind-proxies.html
  siteUrl: process.env.SITE_URL, // SITE URL
  host: `localhost:${process.env.PORT}`,

  api: {  // API Gateway
    clientUrl: '', // API URL to be used in the client-side code
    serverUrl: `http://localhost:${process.env.PORT}`, // API URL to be used in the server-side code
    apiEndpoint: process.env.API_ENDPOINT_URL,
    socketUrl: process.env.SOCKET_URL
  },

  locales: ['en-US', 'es', 'fr-FR', 'ru-RU', 'ja-JP', 'id-ID', 'hr-HR', 'zh-CN', 'sv-SE', 'ar'],

  analytics: { // Web analytics https://analytics.google.com/
    googleTrackingId: 'UA-XXXXX-X', // UA-XXXXX-X
  },

  placeDetailURL: process.env.PLACE_DETAILS_URL,
  autoCompleteURL: process.env.PLACES_AUTOCOMPLETE_URL,
  distanceRouteURL : process.env.DISTANCE_ROUTE_URL,

  profilePhotouploadDir: process.env.PROFILE_PHOTO_UPLOAD_DIR, // Profile photo upload
  categoryUploadDir: process.env.CATEGORY_PHOTO_UPLOAD_DIR, // category photo upload
  logoUploadDir: process.env.LOGO_PHOTO_UPLOAD_DIR, // Logo photo upload
  ogImageUploadDir: process.env.OG_IMAGE_UPLOAD_DIR, // OG Image Upload
  homepageUploadDir: process.env.HOMEPAGE_UPLOAD_DIR, // homepage photo upload
  staticpageUploadDir: process.env.STATICPAGE_UPLOAD_DIR, // staticpage photo upload
  contentPageUploadDir: process.env.CONTENTPAGE_UPLOAD_DIR, //Content page photo upload
  faviconUploadDir: process.env.FAVICON_UPLOAD_DIR, // favicon upload
  subCategoryUploadDir: process.env.SUB_CATEGORY_PHOTO_UPLOAD_DIR, // subCategory photo upload
  documentUploadDir: process.env.DOCUMENT_UPLOAD_DIR, // Document Upload
  homePageCategoryBannerUploadDir: process.env.HOMEPAGE_CATEGORY_BANNER_UPLOAD_DIR, //homepagecategory images
  homePageCategoryLogoUploadDir: process.env.HOMEPAGE_CATEGORY_LOGO_UPLOAD_DIR,
  promoCodeImageUploadDir: process.env.PROMO_CODE_UPLOAD_DIR, //Promocode image directoy
  reviewImageUploadDir: process.env.REVIEW_PHOTO_UPLOAD_DIR,
  toneUploadDir: process.env.TONE_UPLOAD_DIR,
  cmsUploadDir: process.env.CMS_UPLOAD_DIR,
  countryFlagImageDir: process.env.COUNTRY_FLAG_IMAGE_DIR,

  searchLimit: 36,

  analytics: { // Web analytics https://analytics.google.com/
    googleTrackingId: 'UA-XXXXX-X', // UA-XXXXX-X
  },

  unitTypes: {
    km: { value: 'metric', convertFromMeter: 1000 },
    mile: { value: 'imperial', convertFromMeter: 1609 }
  },
  payment : { /* From ENV */
    payPal: {
      returnURL: `${process.env.SITE_URL}${process.env.PAYPAL_RETURN_URL}`,
      cancelURL: `${process.env.SITE_URL}${process.env.PAYPAL_CANCEL_URL}`,
      paymentSuccessURL: `${process.env.SITE_URL}${process.env.PAYPAL_PAYMENT_SUCCESS_URL}`,
      paymentCancelURL: `${process.env.SITE_URL}${process.env.PAYPAL_PAYMENT_CANCEL_URL}`,
      versions: {
        versionOne: '/v1',
        versionTwo: '/v2'
      },
      token_url: '/oauth2/token',
      payment_url: '/checkout/orders',
      capture_url: '/capture',
      payout_url: '/payments/payouts',
      refund: '/refund',
      refund_capture: '/payments/captures/'
    },
  }
};
